import React, { Component } from "react";

class AboutSection extends Component {
  render() {
    const { t } = this.props;
    return (
      <section className="section" id="about">
        <div className="about-grid">
          <div>
            <h2>{t("about.title")}</h2>
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
          </div>
          <div className="about-panel">
            <h3>{t("about.listTitle")}</h3>
            <ul>
              {t("about.listItems").map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutSection;
